/**
 * 结果盘面（原站 st 组件 / atbUMm）。
 *
 * 关键公式来自 bundle：
 *   const list = story.questions.filter(q => q.affect).map(q => selection[q.key].toUpperCase())
 *   agree = list.filter(v => v === 'T').length
 *   disagree = list.filter(v => v === 'F').length
 *   进度条 A: flexBasis = 100 * agree / list.length + '%'
 *   进度条 B: flexBasis = 100 * disagree / list.length + '%'
 *   rank 显示: myResult.rank.toFixed(0).padStart(7, '0')
 *
 * 注意：行数 = affect 为 true 的题目数（本作是 7 题，对应 7 行），
 * 而不是全部 13 题 —— 这正是线上 14.2857%（1/7）的来历。
 *
 * 时间轴（原站 gsap timeline，单位 ms，相对挂载）：
 *   +600   圆环 strokeDashoffset 630 -> 0，1600ms，easeOutCubic
 *   +600   列表项 opacity 0->1 / translateY 50%->0，600ms，easeOutQuart，每项 +100ms
 *   +2000  "synchronized" 淡入，360ms，linear
 *   +2600  结果条与排名淡入，360ms，linear
 */
import { useMemo } from 'react';
import type { MyResult, Quest, Selection } from '../../types';
import { COPY } from '../../types';
import { deriveAnswers, deriveDistribution, formatRank } from '../../lib/derive';
import './dialogue.css';
import './result.css';

const RING_PATH = 'M 100, 100 m 0, -100 a 100,100 0 1,0 0,200 a 100,100 0 1,0 0,-200';

export interface QuestDialProps {
  questions: Quest[];
  selection: Selection;
  myResult: MyResult | null;
}

export function QuestDial({ questions, selection, myResult }: QuestDialProps) {
  const list = useMemo(() => deriveAnswers(questions, selection), [questions, selection]);
  const { agree, disagree, agreePct, disagreePct } = useMemo(() => deriveDistribution(list), [list]);

  return (
    <div className="result">
      <div className="cycle resultCycle">
        <svg viewBox="-2 -2 204 204">
          <path
            className="drawDelayed"
            fill="none"
            strokeWidth={0.2}
            strokeDasharray={630}
            strokeDashoffset={630}
            d={RING_PATH}
          />
        </svg>
      </div>

      <ol className="choiceList">
        {list.map((letter, i) => (
          <li className="choiceItem" style={{ animationDelay: `${600 + i * 100}ms` }} key={i}>
            <span>{(i + 1).toFixed(0)}</span>
            <span>{letter}</span>
          </li>
        ))}
      </ol>

      <div className="finial">{COPY.synchronized}</div>

      <div className="globalResult">
        <div className="resultDistribution">
          {agree > 0 && (
            <div className="resultBar resultA" style={{ flexBasis: `${agreePct}%` }} />
          )}
          {disagree > 0 && (
            <div className="resultBar resultB" style={{ flexBasis: `${disagreePct}%` }} />
          )}
        </div>
        <div className="resultRank">{formatRank(myResult?.rank)}</div>
      </div>
    </div>
  );
}
